import {Component, Input} from '@angular/core';
import {StorageInfo} from '@primatoo-ms-organization';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {ND} from '@pt/pt-models';

@Component({
  selector: 'pt-storage',
  template: `
    <ng-container *ngIf='storageInfo'>
      <label *ngIf='title'>{{ title }}</label>
      <ngb-progressbar
        height='3px'
        class='mb-1'
        type='primary'
        [value]='storageUsedStatus(storageInfo)'
      ></ngb-progressbar>
      {{ storageInfo?.used | number: "1.0-2" }}
      MB {{ (used | async)?.toLowerCase() }} {{ (of | async)?.toLowerCase() }}
      {{ storageInfo?.total | number: "1.0-2" }}
      MB ({{ storageUsedStatus(storageInfo) }}%)
    </ng-container>
    <div *ngIf='!storageInfo'>{{ ND }}</div>
  `,
  styles: [`
    .progress {
      background-color: #ffffff;
    }
  `]
})
export class StorageComponent {
  @Input() title: string;
  @Input() storageInfo: StorageInfo;

  public ND = ND;
  public of: Observable<string> = this.translateService.stream('LABELS.OF');
  public used: Observable<string> = this.translateService.stream('LABELS.USED');

  constructor(private translateService: TranslateService) {
  }

  storageUsedStatus(storageInfo: StorageInfo): number {
    if (storageInfo && storageInfo.used && storageInfo.total) {
      return Math.floor((storageInfo?.used / storageInfo?.total) * 100);
    }
    return 0;
  }
}
